module.exports = __webpack_public_path__ + "static/media/lider.41f4f5e9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/Intro/lider.jpg
// module id = 271
// module chunks = 0